import type { CMSPageType, CMSParentPage } from '@/types/sanity'

export type BreadcrumbItem = {
  label: string
  href?: string
}

const pageTypeToResourceNameMap: { [key: string]: string } = {
  collection: 'collections',
}

const getPageHref = ({ type, slug }: { type: CMSPageType; slug: string }) => {
  const resourceName = pageTypeToResourceNameMap[type]
  if (!resourceName) return

  return `/${resourceName}/${slug}`
}

const getMatchedParentPageByReferrer = ({
  parentPages,
  referrer,
}: {
  parentPages: CMSParentPage[]
  referrer: string
}) => {
  const referrerUrl = new URL(referrer)
  const referrerPath = referrerUrl.pathname

  return parentPages.find(({ _type: type, slug }) => {
    return getPageHref({ type, slug }) === referrerPath
  })
}

export const getBreadcrumbsFromParentPages = ({
  parentPages,
  referrer,
}: {
  parentPages?: CMSParentPage[]
  referrer?: string | null
}) => {
  if (!parentPages?.length) return []

  const parentPage = referrer
    ? getMatchedParentPageByReferrer({ parentPages, referrer }) ||
      parentPages[0]
    : parentPages[0]

  return [parentPage].map(({ _type: type, slug, title }) => ({
    label: title,
    href: getPageHref({ type, slug }),
  }))
}
